export function loadSessionState<T>(key: string): T | undefined {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return undefined;
    return JSON.parse(raw) as T;
  } catch {
    return undefined;
  }
}

export function saveSessionState<T>(key: string, state: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(state));
  } catch {
  }
}

export function throttle<F extends (...args: any[]) => void>(fn: F, ms: number): F {
  let last = 0;
  let timer: number | undefined;

  return function (this: any, ...args: any[]) {
    const now = Date.now();
    const remaining = ms - (now - last);

    if (remaining <= 0) {
      last = now;
      fn.apply(this, args);
    } else {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        last = Date.now();
        fn.apply(this, args);
      }, remaining);
    }
  } as F;
}